import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { RemoveScroll } from 'react-remove-scroll';
import useScreen from 'hooks/useScreen';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useIsMobileUserAgent from 'hooks/useIsMobileUserAgent';
import useIsiPadUserAgent from 'hooks/useIsiPadUserAgent';
import DesktopBodyScrollLock from './DesktopBodyScrollLock';
const BodyScrollLock = t0 => {
  const $ = _c(8);
  const {
    children,
    className: t1,
    enabled: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const enabled = t2 === undefined ? true : t2;
  const {
    isMobile
  } = useScreen();
  const isMobileUserAgent = useIsMobileUserAgent();
  const isiPadUserAgent = useIsiPadUserAgent();
  const shouldUseMobileScrollLocking = isMobile || isMobileUserAgent || isiPadUserAgent;
  if (shouldUseMobileScrollLocking) {
    let t3;
    if ($[0] !== children || $[1] !== className || $[2] !== enabled) {
      t3 = <RemoveScroll className={className} enabled={enabled} removeScrollBar={false}>{children}</RemoveScroll>;
      $[0] = children;
      $[1] = className;
      $[2] = enabled;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== children || $[5] !== className || $[6] !== enabled) {
    t3 = <DesktopBodyScrollLock className={className} enabled={enabled}>{children}</DesktopBodyScrollLock>;
    $[4] = children;
    $[5] = className;
    $[6] = enabled;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
BodyScrollLock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  enabled: PropTypes.bool
};
export default withBrowserOnly(BodyScrollLock);